export enum FunnelGraphicTabEnum {
  BANNER_GENERATOR = 1,
  AI_DESIGN = 2,
}
